import { AND, CONTAINS, Filter, IS_EMPTY, IS_NOT_EMPTY, NOT_CONTAINS, NOT_EQUAL, Operator, OR } from "@dto/records";

// Text-match operators on a linked text field compare the TEXT value of the
// destination field (e.g. Contact -> Company/Sector), not the linked record
// key: the filter carries a plain text value and no record selection.
export function isTextMatchOperator(operator: Operator | undefined): boolean {
    return operator === CONTAINS || operator === NOT_CONTAINS;
}

function singleFilterOf(pathKey: string, operator: Operator, value: any, valueKey: string | null): Filter {
    return {
        singleFilter: {
            pathKey: pathKey,
            operator: operator,
            value: value,
            valueKey: valueKey,
            formula: null
        },
        groupFilter: null
    };
}

// Builds the per-field group filter for a record selection (EQUAL/NOT_EQUAL:
// one single filter per selected record key) or for the no-value operators
// (IS_EMPTY / IS_NOT_EMPTY).
export function buildRecordKeyFilter(pathKey: string, operator: Operator, recordKeys: string[]): Filter {
    const newFieldFilters: Filter[] = [];
    if (operator === IS_EMPTY || operator === IS_NOT_EMPTY) {
        newFieldFilters.push(singleFilterOf(pathKey, operator, null, null));
    } else {
        recordKeys.forEach(recordKey => {
            newFieldFilters.push(singleFilterOf(pathKey, operator, null, recordKey));
        });
    }

    return {
        singleFilter: null,
        groupFilter: {
            filters: newFieldFilters,
            combinator: (operator === NOT_EQUAL ? AND : OR)
        }
    };
}

// Builds the per-field group filter for a text match (CONTAINS/NOT_CONTAINS)
// on the destination field of a linked path: the backend compares the linked
// record's field value, not its key.
export function buildLinkedTextFilter(pathKey: string, operator: Operator, value: any): Filter {
    return {
        singleFilter: null,
        groupFilter: {
            filters: [singleFilterOf(pathKey, operator, value, null)],
            combinator: OR
        }
    };
}
